import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, SearchIcon, ShoppingBagIcon, UserIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { useCart } from '../contexts/CartContext';
const LINKS = [{
  label: 'Inicio',
  to: '/'
}, {
  label: 'Productos',
  to: '/productos'
}, {
  label: 'Nosotros',
  to: '/#nosotros'
}, {
  label: 'Contacto',
  to: '/#contacto'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  const {
    count
  } = useCart();
  const location = useLocation();
  const isActive = (to: string) => to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);
  return <header className="sticky top-0 z-50 w-full border-b border-white/10 bg-black/85 backdrop-blur-md" data-id="element-634" data-mp="9kkv7bqi1gn9">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-5 sm:h-20 lg:px-8" data-id="element-635" data-mp="1pyb36tkqop26">
        <Logo data-id="element-636" data-mp="1l09ftwga63kw" />

        <nav aria-label="Navegación principal" className="hidden items-center gap-9 md:flex" data-id="element-637" data-mp="1kyolo7xvomnk">
          {LINKS.map(link => link.to.includes('#') ? <a key={link.label} href={link.to} className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/60 transition-colors hover:text-white" data-id="element-638" data-mp="em9c6fwxb5vp">
                {link.label}
              </a> : <NavLink key={link.label} to={link.to} className={`relative text-[11px] font-semibold uppercase tracking-[0.18em] transition-colors hover:text-white ${isActive(link.to) ? 'text-white' : 'text-white/60'}`} data-id="element-639" data-mp="3n4f6qwtw67kj">
                {link.label}
                {isActive(link.to) && <span className="absolute -bottom-2 left-0 h-[2px] w-full bg-pink-500" data-id="element-640" data-mp="34do1o7gxt3by" />}
              </NavLink>)}
        </nav>

        <div className="flex items-center gap-1 sm:gap-2" data-id="element-641" data-mp="31b9swd2kau0e">
          <Link to="/productos" aria-label="Buscar productos" className="hidden h-10 w-10 items-center justify-center rounded-full text-white/70 transition-colors hover:bg-white/5 hover:text-white sm:flex" data-id="element-642" data-mp="319ow0gsryyzd">
            <SearchIcon className="h-[18px] w-[18px]" data-id="element-643" data-mp="361gh4bt5wci4" />
          </Link>
          <Link to="/mis-pedidos" aria-label="Mi cuenta y pedidos" className="flex h-10 w-10 items-center justify-center rounded-full text-white/70 transition-colors hover:bg-white/5 hover:text-white" data-id="element-644" data-mp="364cfu2cu357m">
            <UserIcon className="h-[18px] w-[18px]" data-id="element-645" data-mp="2sbmu7z17w2b1" />
          </Link>
          <Link to="/carrito" aria-label={`Carrito, ${count} productos`} className="relative flex h-10 w-10 items-center justify-center rounded-full text-white transition-colors hover:bg-white/5" data-id="element-646" data-mp="2nbs2xudj5apg">
            <ShoppingBagIcon className="h-[18px] w-[18px]" data-id="element-647" data-mp="2krhzavws52h" />
            {count > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-pink-500 px-1 text-[10px] font-bold text-white" data-id="element-648" data-mp="a40uve3milwa">
                {count}
              </span>}
          </Link>
          <button type="button" onClick={() => setOpen(v => !v)} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={open} className="flex h-10 w-10 items-center justify-center rounded-full text-white transition-colors hover:bg-white/5 md:hidden" data-id="element-649" data-mp="55fqr3l93i2k">
            {open ? <XIcon className="h-5 w-5" data-id="element-650" data-mp="k26utq5vdhyi" /> : <MenuIcon className="h-5 w-5" data-id="element-651" data-mp="k0vpvn0ou45t" />}
          </button>
        </div>
      </div>

      {open && <nav aria-label="Navegación móvil" className="border-t border-white/10 bg-black px-5 py-4 md:hidden" data-id="element-652" data-mp="o278v9p23r51">
          <ul className="flex flex-col" data-id="element-653" data-mp="1gl4cjrmrqb1s">
            {LINKS.map(link => <li key={link.label} data-id="element-654" data-mp="3p1nodlh2kr62">
                {link.to.includes('#') ? <a href={link.to} onClick={() => setOpen(false)} className="block border-b border-white/5 py-3 font-display text-xl uppercase tracking-wider text-white/80" data-id="element-655" data-mp="3ozkpebxxvnp7">
                    {link.label}
                  </a> : <Link to={link.to} onClick={() => setOpen(false)} className="block border-b border-white/5 py-3 font-display text-xl uppercase tracking-wider text-white/80" data-id="element-656" data-mp="bnai0v50xjrd">
                    {link.label}
                  </Link>}
              </li>)}
          </ul>
        </nav>}
    </header>;
}